var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "box" }, [
        _c("h1", { staticClass: "subtitle is-4" }, [
          _vm._v(_vm._s(_vm.getTitle)),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-3" }, [
          _vm._v("Certificados de la organización"),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("Filtros", {
        on: { "set-query": _vm.setQuery, refresh: _vm.refresh },
      }),
      _vm._v(" "),
      _c("Listado", { ref: "listado" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Solicitudes y certificados de los usuarios de la organización."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }